/**
 * Ce à quoi se reconnaît une clé de traduction parmi les libellés d'un questionnaire.
 *
 * Les modèles livrés par le serveur — catalogue d'éléments, modèles d'enquête — rangent leurs
 * libellés sous cette forme, et les fichiers `fr.json` / `en.json` les portent tous sous la
 * rubrique `label`. Un texte composé par l'utilisateur ne commence pas ainsi.
 */
export const LABEL_TRANSLATION_PREFIX = 'label.';
